module.exports = __webpack_public_path__ + "media/assets/svgs/linkedin-a2eb75e103db4f56958969e44c4f8003.svg";